import { useEffect } from 'react';

export const useChartPrint = (ref, parentId, size = [630, 280]) => {
    useEffect(() => {
        if (!ref.current) return;

        const parentContainer = document.getElementById(parentId);

        const handleBeforePrint = () => {
            if (ref.current) {
                ref.current.resize(size[0], size[1]);
            }
        };

        const handleAfterPrint = () => {
            if (ref.current) {
                ref.current.resize(parentContainer?.clientWidth, 280);
            }
        };

        window.addEventListener('beforeprint', handleBeforePrint);
        window.addEventListener('afterprint', handleAfterPrint);

        return () => {
            window.removeEventListener('beforeprint', handleBeforePrint);
            window.removeEventListener('afterprint', handleAfterPrint);
        };
    }, [() => ref.current]);
};
